import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import { showGlobalModal } from "./modals/globalModal";
import MessageManager from "./Message";
// import dotenv from "dotenv";

export function getOrgCode() {
  return sessionStorage.getItem("orgCode");
}
export function getTenantId() {
  return sessionStorage.getItem("tenantId");
}

export function getOrgName() {
  return sessionStorage.getItem("organization");
}
export function getEmail() {
  return sessionStorage.getItem("email");
}
export function getUserName() {
  return sessionStorage.getItem("userName");
}

// This function handles errors from API calls and displays appropriate messages
// export const handleApiError = (error, options = {}) => {
//   const {
//     showModal = true,
//     fallbackTitle = "Error",
//     fallbackMessage = "Unexpected error occurred",
//     redirectOn401 = true,
//   } = options;

//   const status = error?.response?.status;
//   const errorData = error?.response?.data;

//   const renderModal = (title, message) => {
//     if (showModal) {
//       showGlobalModal({ title, message, type: "error" });
//     } else {
//       console.warn(`[Silent Error] ${title}: ${message}`);
//     }
//   };

//   if (status === 400 && errorData?.errors) {
//     const errors = errorData.errors;
//     const messages = [];

//     // Safely extract `msg` from each nested error field
//     Object.values(errors).forEach((value) => {
//       if (typeof value === "string") {
//         messages.push(value);
//       } else if (typeof value === "object" && value?.msg) {
//         messages.push(value.msg);
//       } else {
//         messages.push(JSON.stringify(value));
//       }
//     });

//     const finalMessage = messages.join("\n") || fallbackMessage;
//     return renderModal("Validation Error", finalMessage);
//   }

//   if (status === 401) {
//     if (redirectOn401) {
//       sessionStorage.clear();
//       window.location.href = "/";
//     }
//     const msg = errorData?.errors?.server?.msg || "Session expired";
//     return renderModal("Unauthorized", msg);
//   }

//   if (status === 500) {
//     const msg = errorData?.errors?.server?.msg || "Internal Server Error";
//     return renderModal("Server Error", msg);
//   }

//   const fallback =
//     errorData?.message ||
//     errorData?.fullError ||
//     error?.message ||
//     fallbackMessage;

//   return renderModal(fallbackTitle, fallback);
// };

const shownBanners = new Map();

export const handleApiError = (error, options = {}) => {
  const {
    showModal = true,
    fallbackTitle = "Error",
    fallbackMessage = "Unexpected error occurred",
    redirectOn401 = true,
  } = options;

  // Support both Axios-style and custom errors
  const status = error?.response?.status ?? error?.status ?? error?.code; // many backends stick code here

  const errorData = error?.response?.data ?? error;

  const renderModal = (title, message) => {
    if (showModal) {
      showGlobalModal({ title, message, type: "error" });
    } else {
      console.warn(`[Silent Error] ${title}: ${message}`);
    }
  };

  const renderBanner = (message) => {
    const bannerKey = `${status}-${message}`;
    const now = Date.now();
    const lastShown = shownBanners.get(bannerKey);

    // If same banner was shown in last 2 seconds, skip it
    if (lastShown && now - lastShown < 2000) {
      console.log("Duplicate banner suppressed:", bannerKey);
      return;
    }

    shownBanners.set(bannerKey, now);

    // Clean up after 5 seconds
    setTimeout(() => {
      shownBanners.delete(bannerKey);
    }, 5000);

    MessageManager.showBanner("error", message, [
      {
        label: "Refresh",
        type: "primary",
        onClick: () => {
          window.location.reload();
        },
      },
      {
        label: "Dismiss",
        type: "secondary",
        onClick: () => {
          MessageManager.clearAll();
        },
      },
    ]);
  };

  if (status === 400 && (errorData?.errors || errorData?.message)) {
    const messages = [];
    const errs = errorData.errors;
    if (errs && typeof errs === "object") {
      Object.values(errs).forEach((v) => {
        if (typeof v === "string") messages.push(v);
        else if (v?.msg) messages.push(v.msg);
        else messages.push(JSON.stringify(v));
      });
    }
    if (errorData?.message) messages.push(errorData.message);
    const finalMessage = messages.filter(Boolean).join("\n") || fallbackMessage;
    return renderModal("Error", finalMessage);
  }

  if (status === 401) {
    if (redirectOn401) {
      // sessionStorage.clear();
      window.location.href = "/";
    }
    const msg =
      errorData?.errors?.server?.msg || errorData?.message || "Session expired";
    return renderModal("Unauthorized", msg);
  }

  if (status === 500) {
    const msg =
      errorData?.errors?.server?.msg ||
      errorData?.message ||
      "Something went wrong. Please try again";
    return renderBanner(msg);
  }

  const fallback =
    errorData?.message ||
    errorData?.fullError ||
    error?.message ||
    fallbackMessage;
  return renderModal(fallbackTitle, fallback);
};
